import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { Link } from "react-router-dom";
import { getApiBaseUrl, ADD_ACTIVITY, LOGIN } from "../Config/Config";
import { Modal, Input, message } from "antd";

const DummyReport = () => {
  const [visible, setVisible] = useState(false);
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );

  const user = JSON.parse(sessionStorage.getItem("user"));

  const handleExportPDF = () => {
    setVisible(true);
  };

const handlePasswordSubmit = async () => {
  if (!password) {
    message.warning("Please enter your password");
    return;
  }

  setLoading(true);
  const username = user?.UserName || user?.Username;

  try {
    console.log("Login Payload:", JSON.stringify({ username, password }));

    const loginRes = await fetch(`${getApiBaseUrl()}${LOGIN}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, password }),
    });

    const loginData = await loginRes.json();

    if (loginData?.Message === "Login successful")  {
      message.success("Password verified");

      const activityPayload = {
        ActivityType: 1,
        PerformedBy: user?.UserID,
        PerformedOn: new Date().toISOString().slice(0, 19).replace("T", " "),
        Notes: `Report Downloaded by ${username}`,
        Location: "Reports",
        IsSucces: 1,
      };

      const actRes = await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(activityPayload),
      });

      const actData = await actRes.json();

      if (actData?.success) {
        message.success("Activity logged successfully");
      } else {
        message.error("Failed to log activity");
      }

      setVisible(false);
      setPassword("");
      // exportPDF(); // Call your PDF generation/export logic here
    } else {
      message.error("Incorrect password");
    }
  } catch (error) {
    console.error(error);
    message.error("Something went wrong");
  } finally {
    setLoading(false);
    // Don't close modal here unless login was successful
  }
};
  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header d-flex justify-content-end">
            {/* <div className="add-item d-flex">
              <div className="page-title"></div>

              <ul className=" d-flex justify-content-end">
                <li>
                 
                </li>
              </ul>
            </div> */}
            <OverlayTrigger placement="top" overlay={renderTooltip}>
              <Link to="#" onClick={handleExportPDF}>
                <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
              </Link>
            </OverlayTrigger>
          </div>
          <div className="card table-list-card">
            <div className="card-body d-flex m-auto py-4">
              <h3>Reports Coming Soon...</h3>
            </div>
          </div>
        </div>
      </div>
      <Modal
        title="Enter Password to Export PDF"
        open={visible}
        onOk={handlePasswordSubmit}
        onCancel={() => setVisible(false)}
        confirmLoading={loading}
      >
        <Input.Password
          placeholder="Enter your password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </Modal>
    </div>
  );
};

export default DummyReport;
